/**
 * モーダル
 */
import { functions } from '../modules/functions';

export module ModalModule {
  export class Service {
    static modalWrap: HTMLDivElement;

    constructor() {
      document.addEventListener('readCompleteAction', () => {
        Service.modalSetEvent();
        Service.modalSetCloseEvent();
      });
    }

    public static modalSetEvent() {
      const $modalWraps = document.querySelectorAll('modalWrap');
      $modalWraps.forEach($modalWrap => {
        $modalWrap.parentNode?.removeChild($modalWrap);
      });

      Service.modalWrap = document.createElement('div');
      Service.modalWrap.setAttribute('id', 'modalWrap');
      Service.modalWrap.classList.add('modalWrap');
      document.body.appendChild(Service.modalWrap);

      const $targetElements = document.querySelectorAll<HTMLElement>('.modal');
      $targetElements.forEach($targetElement => {
        // idをつける
        const $modalId = $targetElement.getAttribute('id');
        if ($modalId) {
          const $modalIdElements = document.querySelectorAll(`#${$modalId}`);
          if ($modalIdElements.length > 1) {
            const $modalNewId = functions.createUniqueID();
            $targetElement.setAttribute('id', $modalNewId);
          }
        } else {
          const $modalNewId = functions.createUniqueID();
          $targetElement.setAttribute('id', $modalNewId);
        }

        // モーダルを閉じる処理
        document.addEventListener('click', ($event) => {
          const $eventTarget = $event.target as Element;
          if ($eventTarget.classList.contains('modal--isActive')) {
            // モーダルが閉じられ時...
            const top = document.body.style.top;
            //document.body.style.position = '';
            document.body.style.top = '';
            window.scrollTo(0, parseInt(top || '0') * -1);

            $eventTarget.classList.remove('modal--isActive');
            document.documentElement.classList.remove('modal--isOpen');

            const $iframes = $eventTarget.querySelectorAll('iframe');
            $iframes.forEach($iframe => {
              const $src = $iframe.getAttribute('src');
              const $frameborder = $iframe.getAttribute('frameborder');
              const $allow = $iframe.getAttribute('allow');
              if ($src) {
                const $iframeElement = document.createElement('iframe');
                $iframeElement.setAttribute('data-src', $src);
                $iframeElement.setAttribute('frameborder', $frameborder ?? '');
                $iframeElement.setAttribute('allow', $allow ?? '');
                $iframe.parentNode?.replaceChild($iframeElement, $iframe);
              }
            });
          }
          if ($eventTarget.classList.contains('modal__content')) {
            const $modal = $eventTarget.closest('.modal--isActive');
            if ($modal) {
              // モーダルが閉じられ時...
              const top = document.body.style.top;
              //document.body.style.position = '';
              document.body.style.top = '';
              window.scrollTo(0, parseInt(top || '0') * -1);
              window.scrollTo(0, parseInt(top || '0') * -1);

              $modal.classList.remove('modal--isActive');
              document.documentElement.classList.remove('modal--isOpen');
              $event.preventDefault();

              const $iframes = $eventTarget.querySelectorAll('iframe');
              $iframes.forEach($iframe => {
                const $src = $iframe.getAttribute('src');
                const $frameborder = $iframe.getAttribute('frameborder');
                const $allow = $iframe.getAttribute('allow');
                if ($src) {
                  const $iframeElement = document.createElement('iframe');
                  $iframeElement.setAttribute('data-src', $src);
                  $iframeElement.setAttribute('frameborder', $frameborder ?? '');
                  $iframeElement.setAttribute('allow', $allow ?? '');
                  $iframe.parentNode?.replaceChild($iframeElement, $iframe);
                }
              });

              return false;
            }
          }
        });

        // モーダルを開くイベント
        let $EVENT;
        try {
          $EVENT = new Event('modalOpen');
        } catch (e) {
          $EVENT = document.createEvent('Event');
          $EVENT.initEvent('modalOpen', false, true);
        }
        $targetElement.addEventListener('modalOpen', () => {
          Service.modalSetOpenEvent($targetElement);
        }, true);

        // aタグのクリック処理
        const $targetElementId = $targetElement.getAttribute('id');
        if ($targetElementId) {
          document.addEventListener('click', ($event) => {
            let $eventTarget = $event.target as HTMLElement;
            let $nodeName = $eventTarget.nodeName.toLowerCase();
            let $targetId = $eventTarget.getAttribute('data-modal');

            if ('a' !== $nodeName && !$eventTarget.closest('a')) {
              return;
            } else {
              if ('a' !== $nodeName) {
                const $tmp = $eventTarget.closest('a');
                if ($tmp) {
                  $eventTarget = $tmp;
                  $nodeName = $eventTarget.nodeName.toLowerCase();
                  $targetId = $eventTarget.getAttribute('data-modal');
                } else {
                  return;
                }
              }
            }

            if ('a' === $nodeName && null === $eventTarget.getAttribute('href')) {
              return;
            }

            if (!$targetId) {
              $targetId = $eventTarget.getAttribute('href');
              if ($targetId && '#' !== $targetId.slice(0, 1)) {
                return;
              }
            }

            if ($targetId && '#' !== $targetId && '#' + $targetElementId === $targetId) {
              const $modal = document.querySelector<HTMLElement>($targetId);
              if ($modal) {
                $event.preventDefault();

                Service.modalSetOpenEvent($modal);
              }
            }

            return false;
          });
        }
      });
    }

    public static modalSetOpenEvent($modal: HTMLElement) {
      const $modalCloneId = $modal.getAttribute('id') + '-clone';
      const $modalType = $modal.getAttribute('data-modaltype');
      let $modalClone: HTMLElement | null;

      if ($modalCloneId !== Service.modalWrap.querySelector('.modal')?.getAttribute('id')) {
        const $otherModal = Service.modalWrap.querySelector('.modal');
        if ($otherModal) {
          $otherModal?.parentNode?.removeChild($otherModal);
        }
        $modalClone = $modal.cloneNode(true) as HTMLElement;
        $modalClone.setAttribute('id', $modalCloneId);
        Service.modalWrap.appendChild($modalClone);
      } else {
        $modalClone = Service.modalWrap.querySelector<HTMLElement>('.modal');
      }

      if ($modalClone) {
        $modalClone.classList.remove(...$modalClone.classList);
        $modalClone.classList.add('modal');
        if ($modalType) {
          $modalClone.classList.add($modalType);
        }
        // モーダルが開いたら、bodyにfixedを付与
        document.body.style.top = `-${window.scrollY}px`;
        //document.body.style.position = 'fixed';

        setTimeout(() => {
          if ($modalClone) {
            const $iframes = $modalClone.querySelectorAll('iframe');
            $iframes.forEach($iframe => {
              const $src = $iframe.getAttribute('data-src');
              const $frameborder = $iframe.getAttribute('frameborder');
              const $allow = $iframe.getAttribute('allow');
              if ($src && !$iframe.getAttribute('src')) {
                const $iframeElement = document.createElement('iframe');
                $iframeElement.setAttribute('src', $src);
                $iframeElement.setAttribute('frameborder', $frameborder ?? '');
                $iframeElement.setAttribute('allow', $allow ?? '');
                $iframe.parentNode?.replaceChild($iframeElement, $iframe);
              }
            });

            $modalClone.classList.add('modal--isActive');
            document.body.classList.add('modal--isOpen');
          }
        }, 100);
      }
    }

    public static modalSetCloseEvent() {
      document.addEventListener('click', ($event) => {
        const $eventTarget = $event.target as Element;
        if (
          $eventTarget.classList.contains('modal__closeButton') ||
          $eventTarget.closest('.modal__closeButton') ||
          $eventTarget.classList.contains('js__modaCloseButton') ||
          $eventTarget.closest('.js__modaCloseButton')
        ) {
          const $modal = $eventTarget.closest('.modal.modal--isActive');
          if ($modal) {
            $event.preventDefault();

            // モーダルが閉じられ時...
            const top = document.body.style.top;
            //document.body.style.position = '';
            document.body.style.top = '';
            window.scrollTo(0, parseInt(top || '0') * -1);

            $modal.classList.remove('modal--isActive');
            document.documentElement.classList.remove('modal--isOpen');

            const $iframes = $modal.querySelectorAll('iframe');
            $iframes.forEach($iframe => {
              const $src = $iframe.getAttribute('src');
              const $frameborder = $iframe.getAttribute('frameborder');
              const $allow = $iframe.getAttribute('allow');
              if ($src) {
                const $iframeElement = document.createElement('iframe');
                $iframeElement.setAttribute('data-src', $src);
                $iframeElement.setAttribute('frameborder', $frameborder ?? '');
                $iframeElement.setAttribute('allow', $allow ?? '');
                $iframe.parentNode?.replaceChild($iframeElement, $iframe);
              }
            });

            return false;
          }
        }
      });
    }
  }
}
